var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pt-0",attrs:{"cols":"12"}},[_c('LettersList',{attrs:{"title":_vm.title,"headers":_vm.headers,"sendList":_vm.listLetters,"pageType":"AllMyMessage","loading":_vm.loading},on:{"changed":_vm.optionChanged,"search":_vm.searchChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }